import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, AppState } from '../../../store/store';
import { fetchMyReadsUnreadCount } from '../actions/myReadsActions';
import { setMyReadsUnreadCount } from '../slices/myReadsReducer';

const POLLING_INTERVAL = 3600000;

const MyReadsManagerComponent = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { authToken, isLoggedIn } = useSelector((state: AppState) => state.user);
  const pollingIntervalRef = useRef<NodeJS.Timeout | null>(null);

  const refreshMyReads = useCallback(async () => {
    if (!authToken || !isLoggedIn) {
      dispatch(setMyReadsUnreadCount(0));
      return;
    }
    // Uses the dedicated unread-count thunk (not fetchMyReads) so this
    // poller never overwrites the posts/pagination MyReadsPage is showing.
    dispatch(fetchMyReadsUnreadCount());
  }, [authToken, isLoggedIn, dispatch]);

  useEffect(() => {
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
      pollingIntervalRef.current = null;
    }

    if (isLoggedIn && authToken) {
      refreshMyReads();
      pollingIntervalRef.current = setInterval(() => {
        refreshMyReads();
      }, POLLING_INTERVAL);
    } else {
      dispatch(setMyReadsUnreadCount(0));
    }

    return () => {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
        pollingIntervalRef.current = null;
      }
    };
  }, [refreshMyReads, isLoggedIn, authToken, dispatch]);

  return null;
};

export default MyReadsManagerComponent;
